import { Component, Input } from '@angular/core';
import { INTEGRATION_STATUS } from 'voxloud-types/dist/models/integrations/index';

@Component({
  selector: 'gdp-integration-status',
  template: '<div [class]="statusClass" container="body" [ngbTooltip]="handleTooltip | translate : {platform: platformName}">{{"company.integrations.table.status." + status | translate}}</div>'
})
export class IntegrationStatusComponent {
  @Input('status') status: INTEGRATION_STATUS;
  @Input('platformName') platformName: string;
  public statusClass: string;
  private classMapping = {
    [INTEGRATION_STATUS.ACTIVE]: 'vox-chip vox-chip_aquamarine',
    [INTEGRATION_STATUS.WAITING_CONFIGURATION]: 'vox-chip vox-chip_gold',
    [INTEGRATION_STATUS.SUSPENDED]: 'vox-chip vox-chip_bright-crimson',
    [INTEGRATION_STATUS.DISABLED]: 'vox-chip vox-chip_light-grey',
    [INTEGRATION_STATUS.AUTHORIZATION_METHOD_DISABLED]: 'vox-chip vox-chip_bright-crimson-text',
  };
  constructor() { }

  ngOnInit() {
    this.statusClass = this.classMapping[this.status];
  }

  get handleTooltip() {
    if(this.status === INTEGRATION_STATUS.SUSPENDED) {
      return 'company.integrations.table.status.suspended-tooltip';
    } else if(this.status === INTEGRATION_STATUS.AUTHORIZATION_METHOD_DISABLED) {
      return 'company.integrations.table.status.authorization-disabled-tooltip';
    } else {
      return '';
    }
  }
}